import { Hero } from '../Hero/Hero';

import { TakeOurQuizCTA } from '../Hero/TakeOurQuizCTA';

import chrisAndMike from '@public/img/our-story/chris-and-mike.png';

export const OurStoryHero = ({
  utmCampaign,
  utmMedium,
  location,
}: {
  utmCampaign?: string;
  utmMedium?: string;
  location: string;
}): JSX.Element => (
  <Hero
    title={
      <span className="max-w-[560px] text-mono-white">
        Second Nature exists to <span className="text-blue">change minds</span>{' '}
        about losing weight.
      </span>
    }
    color="bg-dawn-blue"
    altText="chris-and-mike"
    placeholder="blur"
    image={chrisAndMike}
    isColourBlockImage
    priority
    ctaChildren={
      <TakeOurQuizCTA
        utmMedium={utmMedium}
        utmCampaign={utmCampaign}
        location={location}
      />
    }
  />
);
